/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Hangi_PazaryerleriInputs */

const tr_faq_a_hangi_pazaryerleri = /** @type {(inputs: Faq_A_Hangi_PazaryerleriInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şu an Trendyol, Hepsiburada, n11 ve Shopify destekleniyor. Her pazaryerini aynı anda bağlayıp tek ekrandan yönetebilirsin. Yeni pazaryeri entegrasyonları yol haritamızda; önceliklendirme için destek ekibimize talep iletebilirsin.`)
};

const en_faq_a_hangi_pazaryerleri = /** @type {(inputs: Faq_A_Hangi_PazaryerleriInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currently Trendyol, Hepsiburada, n11 and Shopify are supported. You can connect all of them at the same time and manage everything from one screen.`)
};

const de_faq_a_hangi_pazaryerleri = /** @type {(inputs: Faq_A_Hangi_PazaryerleriInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derzeit Trendyol, Hepsiburada, n11 und Shopify. Du kannst alle gleichzeitig verbinden und alles über einen Bildschirm verwalten.`)
};

const ru_faq_a_hangi_pazaryerleri = /** @type {(inputs: Faq_A_Hangi_PazaryerleriInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сейчас поддерживаются Trendyol, Hepsiburada, n11 и Shopify. Все можно подключить одновременно и управлять из одного экрана.`)
};

/**
* | output |
* | --- |
* | "Currently Trendyol, Hepsiburada, n11 and Shopify are supported. You can connect all of them at the same time and manage everything from one screen." |
*
* @param {Faq_A_Hangi_PazaryerleriInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_hangi_pazaryerleri = /** @type {((inputs?: Faq_A_Hangi_PazaryerleriInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Hangi_PazaryerleriInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_hangi_pazaryerleri(inputs)
	if (locale === "de") return de_faq_a_hangi_pazaryerleri(inputs)
	if (locale === "ru") return ru_faq_a_hangi_pazaryerleri(inputs)
	return tr_faq_a_hangi_pazaryerleri(inputs)
});